/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
(function($) {
    $(document).ready( function () {
        var $cs = $('.custom-screening');

        if ( $cs.length < 1 ) return; 

        $cs.data('submitted', false);

        $cs.find('input[name="has_screening"]').on('change', function (event) {
            var enabled = $(this).is(':checked');

            $cs.find('.custom-screening__inputs input')
                .prop('disabled', !enabled);

            $cs.find('.custom-screening__inputs')
                .toggleClass('custom-screening__inputs--enabled', enabled);
        });
    });


    window.adjustScreeningProduct = function(params, _callback) {
        $.get('/cart.json', function (cart) {
            // Get the key for the customization product. 
            var screening_product = cart.items.filter( function(item) {
                return (item.properties._screening_id != null 
                    && parseInt(item.properties._screening_id) == parseInt(params.screening_id)
                    && item.properties._screening_product != null); 
            })[0] || null; 

            if ( !screening_product ) {
                if ( typeof _callback === 'function' ) {
                    _callback(null);
                }
                return; 
            }

            $.post('/cart/change.js', {
                id: screening_product.key, 
                quantity: params.quantity
            }, function (response) {
                if ( typeof _callback === 'function') {
                    _callback(response);
                }
            }, 'json'); 
        }, 'json'); 

    }
  
    // File preview modal
    $(document).on('click', 'a[data-trigger-file-preview-modal]', function (e) {
        // Prevents default link action
        e.preventDefault();

        // Extracts image URL
        const $link = $(this);
        const image_url = $link.attr('href');

        // Builds modal
        const $modalBackground = $('<div>')
            .addClass('file-preview-modal-background');
        const $modalBody = $('<div>')
            .addClass('file-preview-modal');
        const $modalClose = $('<a>')
            .text('X')
            .on('click', () => {
                $modalBackground.remove();
                $modalBody.remove();
            })
            .appendTo($modalBody);
        const $modalImage = $('<img>')
            .attr('src', image_url)
            .appendTo($modalBody);

        // Appends modal
        $(document.body)
            .append($modalBackground)
            .append($modalBody);
    });
}(jQuery));


